export default {
  rid: 478,
  borrowerType: 'oc',
  applicableYears: [
    2014,
    2015,
    2016,
    2017,
    2018
  ],
  interimYears: [
    2018
  ],
  name: "FICO 723 Owner's Business",
  hasExistingDebt: false,
  debtSchedulePending: true,
  businessScore: 0,
  timeInBusiness: 9,
  balanceSheetUrl: '',
  profitAndLossDocumentUrls: [],
  taxReturnUrls: [],
  annualizationCoefficient: 4.043,
  interim_periods: [
    {
      to: 'December 31, 2018',
      from: 'January 01, 2018',
      year: 2018,
      __typename: 'InterimPeriod'
    }
  ],
  financial: {
    fiscal_year_end_on: '12/31/2017',
    __typename: 'Financial'
  },
  fiscalYears: [
    {
      rid: 466,
      year: 2018,
      days: 89,
      period: 'interim',
      __typename: 'FiscalYear'
    },
    {
      rid: 449,
      year: 2017,
      days: 365,
      period: 'tax',
      __typename: 'FiscalYear'
    },
    {
      rid: 448,
      year: 2016,
      days: 365,
      period: 'tax',
      __typename: 'FiscalYear'
    },
    {
      rid: 447,
      year: 2015,
      days: 365,
      period: 'tax',
      __typename: 'FiscalYear'
    },
    {
      rid: 446,
      year: 2014,
      days: 365,
      period: 'tax',
      __typename: 'FiscalYear'
    }
  ],
  cashflowData: [
    {
      source: 'manual_document',
      period: null,
      category: 'gross_revenue',
      year: 2014,
      data: 2302,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713936,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'gross_revenue',
      year: 2015,
      data: 203,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713936,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'gross_revenue',
      year: 2016,
      data: 2030,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713937,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'gross_revenue',
      year: 2017,
      data: 38484,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713938,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'gross_revenue',
      year: 2018,
      data: 47248,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713939,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'cogs',
      year: 2014,
      data: 283448,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713940,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'cogs',
      year: 2015,
      data: 48248,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713941,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'cogs',
      year: 2016,
      data: 48,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713942,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'cogs',
      year: 2017,
      data: 8448,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713942,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'cogs',
      year: 2018,
      data: 48,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713943,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'opex',
      year: 2014,
      data: 48,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713943,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'opex',
      year: 2015,
      data: 48,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713943,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'opex',
      year: 2016,
      data: 4842,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713944,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'opex',
      year: 2017,
      data: 1,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713944,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'opex',
      year: 2018,
      data: 9249,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713945,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'interest_expense',
      year: 2015,
      data: 4929249,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713946,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'interest_expense',
      year: 2016,
      data: 4,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713946,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'interest_expense',
      year: 2017,
      data: 924,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713947,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'interest_expense',
      year: 2018,
      data: 24,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713947,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'depreciation',
      year: 2014,
      data: 8,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713947,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'depreciation',
      year: 2015,
      data: 248,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713947,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'depreciation',
      year: 2016,
      data: 4292,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713948,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'depreciation',
      year: 2017,
      data: 24,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713948,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'depreciation',
      year: 2018,
      data: 94,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713949,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'officer_comp',
      year: 2014,
      data: 924,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713949,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'officer_comp',
      year: 2015,
      data: 249,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713950,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'officer_comp',
      year: 2016,
      data: 249,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713950,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'officer_comp',
      year: 2017,
      data: 249,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713950,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'officer_comp',
      year: 2018,
      data: 24999,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713952,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'business_use_of_home_expense',
      year: 2014,
      data: 42716,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713953,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'business_use_of_home_expense',
      year: 2015,
      data: 4742,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713954,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'business_use_of_home_expense',
      year: 2016,
      data: 62462,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713955,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'business_use_of_home_expense',
      year: 2017,
      data: 42647,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713956,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'manual_document',
      period: null,
      category: 'business_use_of_home_expense',
      year: 2018,
      data: 42624,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 1532713958,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'net_profit',
      year: 2014,
      data: -281194,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'net_profit',
      year: 2015,
      data: -48093,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'net_profit',
      year: 2016,
      data: -2860,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'net_profit',
      year: 2017,
      data: 30035,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'net_profit',
      year: 2018,
      data: 153436,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'cash_available_for_debt_service',
      year: 2014,
      data: -237546,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'cash_available_for_debt_service',
      year: 2015,
      data: 4886395,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'cash_available_for_debt_service',
      year: 2016,
      data: 64147,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'cash_available_for_debt_service',
      year: 2017,
      data: 73879,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'cash_available_for_debt_service',
      year: 2018,
      data: 427313,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'ebitda',
      year: 2014,
      data: -238470,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'ebitda',
      year: 2015,
      data: 4886146,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'ebitda',
      year: 2016,
      data: 63898,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'ebitda',
      year: 2017,
      data: 73630,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'ebitda',
      year: 2018,
      data: 326242,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'existing_business_loan_payments',
      year: 2014,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'existing_business_loan_payments',
      year: 2015,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'existing_business_loan_payments',
      year: 2016,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'existing_business_loan_payments',
      year: 2017,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'existing_business_loan_payments',
      year: 2018,
      data: 0,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2014,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2015,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2016,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2017,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'proposed_smartbiz_loan_payments',
      year: 2018,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2014,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2015,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2016,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2017,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_proposed_smartbiz_loan_payments',
      year: 2018,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_business_loan_payments',
      year: 2014,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_business_loan_payments',
      year: 2015,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_business_loan_payments',
      year: 2016,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_business_loan_payments',
      year: 2017,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'total_business_loan_payments',
      year: 2018,
      data: 28864,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_total_business_loan_payments',
      year: 2014,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_total_business_loan_payments',
      year: 2015,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_total_business_loan_payments',
      year: 2016,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_total_business_loan_payments',
      year: 2017,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_total_business_loan_payments',
      year: 2018,
      data: 31413,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'business_dscr',
      year: 2014,
      data: -8.23,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'business_dscr',
      year: 2015,
      data: 169.29,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'business_dscr',
      year: 2016,
      data: 2.22,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'business_dscr',
      year: 2017,
      data: 2.56,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'business_dscr',
      year: 2018,
      data: 14.8,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_business_dscr',
      year: 2014,
      data: -7.56,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_business_dscr',
      year: 2015,
      data: 155.55,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_business_dscr',
      year: 2016,
      data: 2.04,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_business_dscr',
      year: 2017,
      data: 2.35,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    },
    {
      source: 'derived',
      period: null,
      category: 'stressed_business_dscr',
      year: 2018,
      data: 13.6,
      days: 365,
      reason: null,
      resourceType: 'Business',
      createdAt: 0,
      accountable: {
        name: 'Super User',
        __typename: 'Administrator'
      },
      __typename: 'CashflowDatum'
    }
  ],
  financialReviewSegments: [
    {
      title: 'Net Profit & Loss',
      key: 'net_profit_loss',
      categories: [
        {
          key: 'gross_revenue',
          title: 'Gross Revenue',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'cogs',
          title: 'Cost of Goods Sold',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'opex',
          title: 'Operating Expenses',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'net_profit',
          title: 'Net Profit',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    },
    {
      title: 'Cash Available for Debt Service',
      key: 'cash_available_for_debt_service',
      categories: [
        {
          key: 'interest_expense',
          title: 'Interest Expense',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'depreciation',
          title: 'Depreciation',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'amortization',
          title: 'Amortization',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'officer_comp',
          title: 'Officer Compensation',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'business_use_of_home_expense',
          title: 'Business Use of Home Expense',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'expensed_debts',
          title: 'Expensed Debts',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'rent_expense',
          title: 'Rental Expense',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'cre_rent_expense',
          title: 'Rental Expense − CRE',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'business_c_corp_taxes',
          title: 'C-Corp Taxes',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'onetime_expense',
          title: 'One-time Expense',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'onetime_reduction',
          title: 'One-time Reduction',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'cash_available_for_debt_service',
          title: 'Cash Available for Debt Service',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    },
    {
      title: 'Business Debt',
      key: 'business_debt',
      categories: [
        {
          key: 'affiliate_existing_debt',
          title: 'Existing Affiliate Loan Payments',
          required: false,
          derived: false,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'existing_business_loan_payments',
          title: 'Existing Business Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'proposed_smartbiz_loan_payments',
          title: 'Proposed SmartBiz Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'stressed_proposed_smartbiz_loan_payments',
          title: 'Stressed Proposed SmartBiz Loan Payments',
          required: false,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'total_business_loan_payments',
          title: 'Total Annual Business Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'stressed_total_business_loan_payments',
          title: 'Stressed Total Business Loan Payments',
          required: false,
          derived: true,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    },
    {
      title: 'Business Debt Service Coverage Ratio',
      key: 'business_dscr',
      categories: [
        {
          key: 'business_dscr',
          title: 'Business Debt Service Coverage Ratio',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'stressed_business_dscr',
          title: 'Stressed Business Debt Service Coverage Ratio',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    },
    {
      title: 'Global Business Categories',
      key: 'global',
      categories: [
        {
          key: 'ebitda',
          title: '${Business} EBITDA',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'existing_business_loan_payments',
          title: '${Business} Existing Loan Payments',
          required: true,
          derived: true,
          __typename: 'FinancialReviewCategory'
        },
        {
          key: 'affiliate_existing_debt',
          title: '${Business} Existing Loan Payments',
          required: true,
          derived: false,
          __typename: 'FinancialReviewCategory'
        }
      ],
      __typename: 'FinancialReviewSegment'
    }
  ],
  taxReturns: [
    {
      year: '2018',
      formName: '1040C',
      rid: 450,
      __typename: 'TaxReturn'
    },
    {
      year: '2017',
      formName: '1040C',
      rid: 449,
      __typename: 'TaxReturn'
    },
    {
      year: '2016',
      formName: '1040C',
      rid: 448,
      __typename: 'TaxReturn'
    },
    {
      year: '2015',
      formName: '1040C',
      rid: 447,
      __typename: 'TaxReturn'
    },
    {
      year: '2014',
      formName: '1040C',
      rid: 446,
      __typename: 'TaxReturn'
    }
  ],
  balanceSheet: null,
  guarantors: [
    {
      rid: 432,
      name: 'E Brackin',
      spouse: null,
      filing_status: null,
      creditDataUrls: [],
      creditScore: 0,
      jointAccountAmount: 0,
      residenceMonthlyPaymentFromCredit: null,
      scheduledMonthlyPaymentsFromCredit: 0,
      interimYears: [
        2018
      ],
      business: {
        rid: 332,
        __typename: 'Business'
      },
      taxReturnUrls: [],
      fiscalYears: [
        {
          rid: 198,
          year: 2018,
          days: 243,
          period: 'interim',
          isFullYear: false,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 197,
          year: 2017,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 196,
          year: 2016,
          days: 366,
          period: 'tax',
          isFullYear: true,
          isLeapYear: true,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 195,
          year: 2015,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 194,
          year: 2014,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        },
        {
          rid: 193,
          year: 2013,
          days: 365,
          period: 'tax',
          isFullYear: true,
          isLeapYear: false,
          annualizationCoefficient: 1,
          __typename: 'FiscalYear'
        }
      ],
      cashflowData: [
        {
          source: 'derived',
          period: null,
          category: 'housing_yearly_payments',
          year: 2014,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'housing_yearly_payments',
          year: 2015,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'housing_yearly_payments',
          year: 2016,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'housing_yearly_payments',
          year: 2017,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'housing_yearly_payments',
          year: 2018,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'scheduled_yearly_payments',
          year: 2014,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'scheduled_yearly_payments',
          year: 2015,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'scheduled_yearly_payments',
          year: 2016,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'scheduled_yearly_payments',
          year: 2017,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'scheduled_yearly_payments',
          year: 2018,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'annual_personal_debt_payments',
          year: 2014,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'annual_personal_debt_payments',
          year: 2015,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'annual_personal_debt_payments',
          year: 2016,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'annual_personal_debt_payments',
          year: 2017,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        },
        {
          source: 'derived',
          period: null,
          category: 'annual_personal_debt_payments',
          year: 2018,
          data: 0,
          reason: null,
          resourceType: 'Guarantor',
          createdAt: 0,
          accountable: {
            name: 'Admin Billfloat',
            __typename: 'Administrator'
          },
          __typename: 'CashflowDatum'
        }
      ],
      financialReviewSegments: [
        {
          title: 'Income',
          key: 'income',
          categories: [
            {
              key: 'wage_income',
              title: 'Wages',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'guaranteed_payments',
              title: 'Guaranteed Payments',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'social_security_benefits',
              title: 'Social Security Benefits',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'rental_real_estate_revenue',
              title: 'Rental Real Estate Revenue',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'rental_mortgage_interest',
              title: 'Rental Real Estate Interest',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'rental_real_estate_depreciation',
              title: 'Rental Real Estate Depreciation',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'other_business_cashflow',
              title: 'Schedule C Cash Flow (side-business)',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'pensions_and_annuities',
              title: 'Pensions (recurring)',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'ira_distributions',
              title: 'IRA Distributions (recurring)',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'total_income',
              title: 'Total Income',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'other_personal_income',
              title: 'Other Personal Income',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Expenses',
          key: 'expenses',
          categories: [
            {
              key: 'rental_real_estate_expenses',
              title: 'Rental Real Estate Expenses',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'federal_taxes',
              title: 'Federal Taxes',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'state_taxes',
              title: 'State Taxes',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'real_estate_taxes',
              title: 'Real Estate Taxes',
              required: true,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'other_tax_return_adjustments',
              title: 'Other Tax Return Adjustments',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'other_personal_expenses',
              title: 'Other Personal Expenses',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'c_corp_taxes',
              title: 'C-Corp Taxes',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'vehicle_expensed',
              title: 'Vehicle Expensed',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'schedule_f_ebitda',
              title: 'Schedule F EBITDA',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'home_mortgage_expense',
              title: 'Home Mortgage Expense',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'living_expense',
              title: 'Living Expense',
              required: false,
              derived: true,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'total_expenses',
              title: 'Total Expenses',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Personal Cash Flow',
          key: 'personal_cashflow',
          categories: [
            {
              key: 'net_personal_cashflow',
              title: 'Net Personal Cash Flow',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        },
        {
          title: 'Personal Debt',
          key: 'personal_debt',
          categories: [
            {
              key: 'amex',
              title: 'AMEX',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'rental_property_mortgage_debt',
              title: 'Rental Property Mortgage Debt',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'additional_personal_debt',
              title: 'Additional Personal Debts',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'debt_already_counted',
              title: 'Debt Already Counted',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'student_loan',
              title: 'Student Loans',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'zero_balance_tradelines',
              title: 'Zero Balance Tradelines',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'irs_payment_plan',
              title: 'IRS Payment Plan',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'additional_spousal_debt',
              title: 'Additional Spousal Debt',
              required: false,
              derived: false,
              __typename: 'FinancialReviewCategory'
            },
            {
              key: 'annual_personal_debt_payments',
              title: 'Total Annual Personal Debt Payments',
              required: true,
              derived: true,
              __typename: 'FinancialReviewCategory'
            }
          ],
          __typename: 'FinancialReviewSegment'
        }
      ],
      taxReturns: [],
      personalFinancial: {
        cashInBanks: 200,
        marketableSecurities: 4304,
        installmentLoans: 424,
        creditCards: 4444,
        otherAssets: 24942,
        otherLiabilities: 49294,
        realEstate: 4244,
        lifeInsurance: 49294,
        retirementAccounts: 29023,
        otherMortgages: 49499,
        __typename: 'FinancialPersonal'
      },
      __typename: 'Guarantor'
    }
  ],
  outstandingLoans: [],
  __typename: 'Business'
}
